<template>
  <div class="project-status mt-4">
    <div class="media mb-0">
      <p>{{percent}}%</p>
    </div>
    <div class="progress" style="height: 5px">
      <div
          class="progress-bar-animated progress-bar-striped bg-primary"
          role="progressbar"
          :style= "{'width': percent + '%'}"
          aria-valuenow="10"
          aria-valuemin="0"
          aria-valuemax="100"
      ></div>
    </div>
  </div>
  <!--  <div style="padding: 0 20px">-->
  <!--    <div class="progress-box" v-if="percent">-->
  <!--      <div-->
  <!--          class="progress sm-progress-bar progress-animate app-right"-->
  <!--      >-->
  <!--        <div-->
  <!--            class="progress-gradient-light"-->
  <!--            role="progressbar"-->
  <!--            :style="{ width: percent + '%' }"-->
  <!--            aria-valuemin="0"-->
  <!--            aria-valuemax="100"-->
  <!--        >-->
  <!--          <span style="color: white">{{ percent }}%</span>-->
  <!--          <span class="animate-circle"></span>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->

  <!--    <svg-->
  <!--        v-if="waiting > 0 && isMentor"-->
  <!--        style="width: 30px;position:absolute; bottom: 10px; right: 10px;color: red;animation: tada 1.5s ease infinite;"-->
  <!--        xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"-->
  <!--        fill="currentColor">-->
  <!--      <path fill-rule="evenodd"-->
  <!--            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"-->
  <!--            clip-rule="evenodd"/>-->
  <!--    </svg>-->

  <!--  </div>-->
</template>

<script>

export default {
  name: 'ProjectProcess',
  props: {
    project: {
      type: Object,
      default: function () {
        return {
          percent: null,
          waiting: 0
        }
      }
    }
  },
  data() {
    return {};
  },
  created() {

    let steps = 0
    let approved = 0
    this.waiting = 0
    this.project.steps.forEach((item) => {

      steps++

      if (item.is_active == 3) {
        approved++
      }

      if (item.is_active == 2) {
        this.waiting++
      }
    })

    this.percent = parseInt(+(100 * approved / steps), 10)
  },
  computed: {
    isMentor: function () {

      let user = this.$store.getters['shared/getUser']

      if (!user) {
        return null
      }

      if (!this.project) {
        return null
      }

      let currentUserRoles = this.project.share.find((item) => {
        return item.user_id == user.id
      })

      return currentUserRoles.is_mentor
    }
  }
};
</script>

<style>

/*.progress-gradient-primary {*/
/*  background-image: linear-gradient(to right, transparent, white) !important;*/
/*}*/

/*.progress-gradient-primary .animate-circle {*/
/*  border: 3px solid white !important;*/
/*}*/


</style>